import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import AdmissionsHome from "./Admissions_Home";
import HighlightsHome from "./Highlights_Home";
import AnnouncementsHome from "./Announcements_Home";
// Home sections shown below the main tabbed content
import PartnersHome from "./Partners_Home";
import NewsEventsHome from "./NewsEvents_Home";

import "./Welcome_Home.css"; // Ensure styles are available

const tabOrder = ["announcements", "admissions", "highlights"];

function HomeText() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("announcements");
  const [direction, setDirection] = useState(0);

  // Listen for hash changes and switch to the matching tab
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash && tabOrder.includes(hash)) {
      if (hash !== activeTab) {
        const oldIndex = tabOrder.indexOf(activeTab);
        const newIndex = tabOrder.indexOf(hash);
        setDirection(newIndex > oldIndex ? 1 : -1);
        setActiveTab(hash);
      }

      // Always scroll to the home container when a valid tab hash is present
      setTimeout(() => {
        const el = document.getElementById("home-section");
        if (el) {
          const pos = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: pos - 80, behavior: "smooth" });
        }
      }, 100);
    }
  }, [location.hash]);

  const handleTabChange = (tab) => {
    const oldIndex = tabOrder.indexOf(activeTab);
    const newIndex = tabOrder.indexOf(tab);
    setDirection(newIndex > oldIndex ? 1 : -1);
    setActiveTab(tab);
  };

  const variants = {
    initial: (dir) => ({
      y: dir > 0 ? "100%" : "-100%",
      opacity: 0,
    }),
    animate: {
      y: "0%",
      opacity: 1,
      transition: { duration: 0.4 },
    },
    exit: (dir) => ({
      y: dir > 0 ? "-100%" : "100%",
      opacity: 0,
      transition: { duration: 0.4 },
    }),
  };

  const renderContent = () => {
    if (activeTab === "announcements") {
      return <AnnouncementsHome />;
    } else if (activeTab === "admissions") {
      return <AdmissionsHome />;
    } else if (activeTab === "highlights") {
      return <HighlightsHome />;
    }
  };

  return (
    <div id="home-section" className="home-container">
      <div className="content-wrapper">
        <div className="content-area">
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={activeTab}
              custom={direction}
              variants={variants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="main-content"
            >
              {renderContent()}
            </motion.div>
          </AnimatePresence>

          <div className="side-panel">
            <button
              className={`panel-button announcements-button ${
                activeTab === "announcements" ? "active" : ""
              }`}
              onClick={() => handleTabChange("announcements")}
            >
              Announcements
            </button>
            <button
              className={`panel-button admissions-button ${
                activeTab === "admissions" ? "active" : ""
              }`}
              onClick={() => handleTabChange("admissions")}
            >
              Admissions
            </button>
            <button
              className={`panel-button highlights-button ${
                activeTab === "highlights" ? "active" : ""
              }`}
              onClick={() => handleTabChange("highlights")}
            >
              Highlights
            </button>
          </div>
        </div>
        {/* Partners carousel + News & Events always rendered below the main tabbed area */}
        <div className="home-lower-sections">
          <PartnersHome />
          <NewsEventsHome />
        </div>
      </div>
    </div>
  );
}

export default HomeText;
